const AlgeriaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_110724)">
      <path
        d="M20.0003 0C31.0459 0 40.0003 8.95437 40.0003 20C40.0003 31.0456 31.0459 40 20.0003 40C20.0003 39.1305 17.3916 20 17.3916 20L20.0003 0Z"
        fill="#F0F0F0"
      />
      <path d="M20 40C8.95437 40 0 31.0456 0 20C0 8.95437 8.95437 0 20 0" fill="#496E2D" />
      <path
        d="M24.2966 16.1631L22.6556 18.4244L19.998 17.5625L21.6416 19.8219L20.0009 22.0832L22.6574 21.2183L24.301 23.4776L24.2993 20.6838L26.9559 19.8188L24.2984 18.9571L24.2966 16.1631Z"
        fill="#D80027"
      />
      <path
        d="M21.6587 25.6517C18.5371 25.6517 16.0065 23.1211 16.0065 19.9995C16.0065 16.878 18.5371 14.3473 21.6587 14.3473C22.632 14.3473 23.5479 14.5934 24.3474 15.0267C23.093 13.8001 21.3777 13.043 19.4848 13.043C15.6428 13.043 12.5283 16.1575 12.5283 19.9995C12.5283 23.8414 15.6429 26.9559 19.4848 26.9559C21.3778 26.9559 23.0931 26.1988 24.3474 24.9722C23.5479 25.4056 22.632 25.6517 21.6587 25.6517Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_110724">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default AlgeriaSvg;
